import { LoanEditorActionsEnum } from 'constants/loanActionEditor';

export const SnapdocsFieldEnum = {
  SIGNING_METHOD: 'signingMethod',
  TARGET_SIGNING_METHOD: 'targetSigningMethod',
  BRANDING_KEY: 'brandingKey',
  DOCUMENT_TYPES: 'documentTypes',
  SCANBACKS_REQUIRED: 'scanbacksRequired',
  DOCUMENT_RETURN_METHOD: 'documentReturnMethod',
  INSTRUCTIONS: 'instructions',
  TEXT: 'text',
  SETTLEMENT_AGENT_VISIBLE: 'settlementAgentVisible',
  CONSUMER_VISIBLE: 'consumerVisible',
  REASON: 'reason',
  PROMPT_AT_EXECUTION: 'promptAtExecution',
};

export const snapdocsFieldsByActionType = {
  [LoanEditorActionsEnum.SEND_CLOSING_TO_SNAPDOCS]: [
    SnapdocsFieldEnum.SIGNING_METHOD,
    SnapdocsFieldEnum.BRANDING_KEY,
    SnapdocsFieldEnum.DOCUMENT_TYPES,
  ],
  [LoanEditorActionsEnum.FULL_REDRAW_SNAPDOCS_CLOSING]: [
    SnapdocsFieldEnum.SIGNING_METHOD,
    SnapdocsFieldEnum.DOCUMENT_TYPES,
  ],
  [LoanEditorActionsEnum.PARTIAL_REDRAW_SNAPDOCS_CLOSING]: [SnapdocsFieldEnum.DOCUMENT_TYPES],
  [LoanEditorActionsEnum.CONVERT_SNAPDOCS_SIGNING_METHOD]: [
    SnapdocsFieldEnum.TARGET_SIGNING_METHOD,
  ],
  [LoanEditorActionsEnum.REQUEST_SNAPDOCS_NOTARY]: [
    SnapdocsFieldEnum.SCANBACKS_REQUIRED,
    SnapdocsFieldEnum.DOCUMENT_RETURN_METHOD,
    SnapdocsFieldEnum.INSTRUCTIONS,
  ],
  [LoanEditorActionsEnum.POST_SNAPDOCS_COMMENT]: [
    SnapdocsFieldEnum.TEXT,
    SnapdocsFieldEnum.SETTLEMENT_AGENT_VISIBLE,
    SnapdocsFieldEnum.CONSUMER_VISIBLE,
    SnapdocsFieldEnum.PROMPT_AT_EXECUTION,
  ],
  [LoanEditorActionsEnum.OPT_OUT_SNAPDOCS_ESIGNING]: [
    SnapdocsFieldEnum.REASON,
    SnapdocsFieldEnum.PROMPT_AT_EXECUTION,
  ],
};

export const EMPTY_FIELDS = [];

export const EMPTY_DOCUMENT_TYPES = [];

export const COMPANY_DEFAULT_PLACEHOLDER = 'Company default';

export const signingMethodCopy = {
  optional: { label: 'Signing Method', placeholder: COMPANY_DEFAULT_PLACEHOLDER },
  required: { label: 'New Signing Method', placeholder: 'Select a signing method' },
};

export const MULTILINE_ROWS = 3;

export const PROMPT_AT_EXECUTION_PLACEHOLDER = 'Entered by the user at execution';

export const promptAtExecutionLabelByActionType = {
  [LoanEditorActionsEnum.POST_SNAPDOCS_COMMENT]: 'Ask for the comment when the action runs',
  [LoanEditorActionsEnum.OPT_OUT_SNAPDOCS_ESIGNING]: 'Ask for the reason when the action runs',
};
